import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { plants } from './data/plants';
import PlantPopup from './components/PlantPopup';
import { renderPopup } from './utils/renderPopup';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN!;

const MapView: React.FC = () => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const mapRef = useRef<mapboxgl.Map | null>(null);

  useEffect(() => {
    if (mapRef.current || !mapContainer.current) return;

    // Initialize map
    mapRef.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [-111.9345, 33.4242], // Greater Phoenix Area / ASU Tempe
      zoom: 14,
    });

    // Add zoom & rotation controls
    mapRef.current.addControl(new mapboxgl.NavigationControl());

    // Add markers with React-powered popups
    plants.forEach((plant) => {
      const el = document.createElement('div');
      el.style.backgroundImage = `url(${plant.icon})`;
      el.style.width = '32px';
      el.style.height = '32px';
      el.style.backgroundSize = 'cover';
      el.style.borderRadius = '50%';
      el.style.cursor = 'pointer';

      new mapboxgl.Marker(el)
        .setLngLat(plant.coords)
        .setPopup(renderPopup(<PlantPopup plant={plant} />, { maxWidth: '380px' }))
        .addTo(mapRef.current!);
    });
  }, []);

  return <div ref={mapContainer} className="w-full h-screen" />;
};

export default MapView;
